(function ($) {
  $.validationEngineLanguage = {
    zh_CN: {
      "queryReport": {
        "regex": "none",
        "alertText": "*'状态上报周期'必须是'查询机器周期'的整数倍"
      },
      "giveName": {
        "regex": /^[a-zA-Z0-9_\-\u4e00-\u9fa5]+$/i,
        "alertText": "*命名无效"
      },
      "alias": {
        "regex": /^[a-zA-Z0-9_\-\u4e00-\u9fa5]+$/i,
        "alertText": "*无效的别名"
      },
      "username": {
        "regex": /^[A-Za-z0-9_\-]+$/,
        "alertText": "*无效用户名"
      },
      "required": { // Add your regex rules here, you can take telephone as an example
        "regex": "none",
        "alertText": "* 此处不可空白",
        "alertTextCheckboxMultiple": "* 请选择一个项目",
        "alertTextCheckboxe": "* 您必须钩选此栏",
        "alertTextDateRange": "* 日期范围不可空白"
      },
      "requiredInFunction": {
        "func": function (field, rules, i, options) {
          return (field.val() == "test") ? true : false;
        },
        "alertText": "* Field must equal test"
      },
      "dateRange": {
        "regex": "none",
        "alertText": "* 无效的 ",
        "alertText2": " 日期范围"
      },
      "dateTimeRange": {
        "regex": "none",
        "alertText": "* 无效的 ",
        "alertText2": " 时间范围"
      },
      "minSize": {
        "regex": "none",
        "alertText": "* 最少 ",
        "alertText2": " 个字符"
      },
      "maxSize": {
        "regex": "none",
        "alertText": "* 最多 ",
        "alertText2": " 个字符"
      },
      "groupRequired": {
        "regex": "none",
        "alertText": "* 你必需选填其中一个栏位"
      },
      "min": {
        "regex": "none",
        "alertText": "* 最小值為 "
      },
      "max": {
        "regex": "none",
        "alertText": "* 最大值为 "
      },
      "past": {
        "regex": "none",
        "alertText": "* 日期必需早于 "
      },
      "future": {
        "regex": "none",
        "alertText": "* 日期必需晚于 "
      },
      "maxCheckbox": {
        "regex": "none",
        "alertText": "* 最多选取 ",
        "alertText2": " 个项目"
      },
      "minCheckbox": {
        "regex": "none",
        "alertText": "* 请选择 ",
        "alertText2": " 个项目"
      },
      "password": {
//                	"regex": /^[A-Za-z0-9_\!\@\#\$\%\^\&\*\.]+$/,
        "regex": /^[A-Za-z0-9_\!\@\#\$\%\^\&\*\.\+\=\-\~\,\[\]\(\)]+$/,
        "alertText": "* 包含非法字符"
      },
      "equals": {
        "regex": "none",
        "alertText": "* 请输入与上面相同的密码"
      },
      "creditCard": {
        "regex": "none",
        "alertText": "* 无效的信用卡号码"
      },
      "serialNumber2": {
        "regex": /^[a-zA-Z]{2}[0-9]{13}$/,
        "alertText": "* 请输入15位网关序列号"
      },
      "serialNumber": {
        "regex": /^[a-zA-Z0-9]+$/,
        "alertText": "* 只能输入字母和数字"
      },
      "phone": {
        // credit: jquery.h5validate.js / orefalo
        "regex": /^([\+][0-9]{1,3}[ \.\-])?([\(]{1}[0-9]{2,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
        "alertText": "* 无效的传真号码"
      },
      "phone1": {
        // credit: jquery.h5validate.js / orefalo
        "regex": /^(\+?[0-9]{2,4}\-?\s?)?([0-9]{3,4}\-?\s?)?([0-9]{7,8})(\-[0-9]+)?$/,
//                	"regex": /^(\+[0-9]+\-?\s?)?([0-9]+\-?\s?)?([0-9]+)(\-[0-9]+)?$/,
//                	"regex": /^((\+?[0-9]{2,4}\-[0-9]{3,4}\-)|([0-9]{3,4}\-))?([0-9]{7,8})(\-[0-9]+)?$/,
        "alertText": "* 无效的电话号码"
      },
      "mobile": {
        "regex": /^1[3|4|5|8][0-9]\d{8,8}$/,
        "alertText": "* 无效的手机号码"
      },
      "email": {
        // Shamelessly lifted from Scott Gonzalez via the Bassistance Validation plugin http://projects.scottsplayground.com/email_address_validation/
        "regex": /^admin$|^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
        "alertText": "* 邮件地址无效"
      },
      "emailExist": {
        "alertText": "* 邮件地址不存在"
      },
      "integer": {
        "regex": /^[\-\+]?\d+$/,
        "alertText": "* 不是有效的整数"
      },
      "number": {
        // Number, including positive, negative, and floating decimal. credit: orefalo
        "regex": /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/,
        "alertText": "* 无效的数字"
      },
      "date": {
        "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/,
        "alertText": "* 无效的日期，格式必需为 YYYY-MM-DD"
      },
      "ipv4": {
        "regex": /^((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d)(\.((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d)){3}$|^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/,
        "alertText": "* 无效的 IP 地址"
      },
      "url": {
        "regex": /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
        "alertText": "* 无效的 URL"
      },
      "url1": {
        "regex": /^((https?|ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
        "alertText": "* 无效的 URL"
      },
      "onlyNumberSp": {
        "regex": /^[0-9]+$/,
        "alertText": "* 只能填数字"
      },
      "onlyFiveNumber": {
        "regex": /^(\d\d\d\d\d)$/,
        "alertText": "* 只能填5位数字"
      },
      "onlyLetterSp": {
        "regex": /^[a-zA-Z\ \']+$/,
        "alertText": "* 只接受英文字母大小写"
      },
      "onlyLetterNumber": {
        "regex": /^[0-9a-zA-Z]+$/,
        "alertText": "* 不接受特殊字符"
      },
      // --- CUSTOM RULES -- Those are specific to the demos, they can be removed or changed to your likings
      "ajaxUserCall": {
        "url": "ajaxValidateFieldUser",
        // you may want to pass extra data on the ajax call
        "extraData": "name=eric",
        "alertText": "* 此名称已被其他人使用",
        "alertTextLoad": "* 正在确认名称是否有其他人使用，请稍等。"
      },
      "ajaxUserCallPhp": {
        "url": "phpajax/ajaxValidateFieldUser.php",
        // you may want to pass extra data on the ajax call
        "extraData": "name=eric",
        // if you provide an "alertTextOk", it will show as a green prompt when the field validates
        "alertTextOk": "* 此帐号名称可以使用",
        "alertText": "* 此名称已被其他人使用",
        "alertTextLoad": "* 正在确认帐号名称是否有其他人使用，请稍等。"
      },
      "ajaxNameCall": {
        // remote json service location
        "url": "ajaxValidateFieldName",
        // error
        "alertText": "* 此名称可以使用",
        // if you provide an "alertTextOk", it will show as a green prompt when the field validates
        "alertTextOk": "* 此名称已被其他人使用",
        // speaks by itself
        "alertTextLoad": "* 正在确认名称是否有其他人使用，请稍等。"
      },
      "ajaxNameCallPhp": {
        // remote json service location
        "url": "phpajax/ajaxValidateFieldName.php",
        // error
        "alertText": "* 此名称已被其他人使用",
        // speaks by itself
        "alertTextLoad": "* 正在确认名称是否有其他人使用，请稍等。"
      },
      "validate2fields": {
        "alertText": "* 请输入 HELLO"
      },
      //tls warning:homegrown not fielded
      "dateFormat": {
        "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/,
        "alertText": "* 无效的日期格式"
      },
      //tls warning:homegrown not fielded
      "dateTimeFormat": {
        "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1}$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^((1[012]|0?[1-9]){1}\/(0?[1-9]|[12][0-9]|3[01]){1}\/\d{2,4}\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1})$/,
        "alertText": "* 无效的日期或时间格式",
        "alertText2": "可接受的格式： ",
        "alertText3": "mm/dd/yyyy hh:mm:ss AM|PM 或 ",
        "alertText4": "yyyy-mm-dd hh:mm:ss AM|PM"
      },
      "systemAuthcode": {
        "regex": /^[0-9,a-z,A-Z]{5}$/,
        "alertText": "* 无效的验证码"
      },
      "smsCode": {
        "regex": /^[0-9]{6}$/,
        "alertText": "* 无效的验证码"
      },
      "nohtml": {
        "alertText": "* 包含非法字符 "
      },
      "ip": {
        "regex": /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
        "alertText": "* 无效的IP地址"
      },
      "baudRate": {
        "func": function (field, rules, i, options) {
          var value = field.val();
          var baudRates = ["110", "300", "600", "1200", "2400", "4800", "9600", "19200", "38400", "57600", "115200"];
          if (baudRates.indexOf(value) != -1) {
            return true;
          } else {
            return false;
          }
        },
        "alertText": "* 无效的波特率"
      },
      "parity": {
        "func": function (field, rules, i, options) {
          var value = field.val();
          var baudRates = ["N", "O", "E"];
          if (baudRates.indexOf(value) != -1) {
            return true;
          } else {
            return false;
          }
        },
        "alertText": "* 无效的校验位"
      }
    }
  };

})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./cloud/resources/language/zh_CN/validationengine.lang.js
// module id = 57
// module chunks = 0 6 7 8 9 16 17 25 26 27 28 32 33 34 41 44 45 46 51